import React from "react";
import { useReactAppState } from "../../containers/utils";
import { getClubsDir } from "../../utils";
import { trackClubClick } from "../../../../libraries/_modules/tracking/snowplow/trackClubInteraction";

const ClubName = ({ slug, name, abbreviation, isAbbreviationOnly, element_position, ...club }) => {
  const { isLeague, urlList } = useReactAppState();
  const { baseUrl } = urlList || {};

  const handleClubClick = (e) => {
    e.preventDefault();
    const href = e.currentTarget.href;

    trackClubClick({
      clubData: {
        id: club.id,
        name
      },
      element_name: slug,
      element_type: "club",
      element_position,
    });

    setTimeout(() => {
      window.location.href = href;
    }, 100);
  };

  return (
    (isAbbreviationOnly) ?
      <a href={`${baseUrl}/${getClubsDir()}/${slug}`} title={abbreviation} className="mls-o-table__club-link" onClick={handleClubClick}>
        <span className="mls-o-table__abbr">{abbreviation}</span>
      </a>
      :
      isLeague ?
        <a href={`${baseUrl}/${getClubsDir()}/${slug}`} title={name} className="mls-o-table__club-link" onClick={handleClubClick}>
          <span className="mls-o-table__name">{name}</span>
          <span className="mls-o-table__abbreviation">{abbreviation}</span>
        </a>
        :
        <>
          <span className="mls-o-table__name">{name}</span>
          <span className="mls-o-table__abbreviation">{abbreviation}</span>
        </>
  );
};

export default ClubName;
